import { render, staticRenderFns } from "./editRowBelniz.vue?vue&type=template&id=4155a7bf&"
import script from "./editRowBelniz.vue?vue&type=script&lang=js&"
export * from "./editRowBelniz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports